
import React from 'react'
import NavBarTop from '../../NavBar_Top/NavBar_Top';
import Privacidade from './../../PoliticaPrivacidade/PoliticaPrivacidade';
import Rodape from '../../Rodape/Rodape';
import Box from '@mui/material/Box';

function Privacidades() {
  return (    
    <div>      
      <NavBarTop />         
      <Privacidade />      
      <Rodape />
    </div>
  )
}
export default Privacidades